export function findClosest(node: Node, selector: string, stopSelector?: string): HTMLElement {
    if (!node) return;

    let el: HTMLElement = node.nodeType === Node.TEXT_NODE ? node.parentElement : (node as HTMLElement);
    if (el.nodeType === Node.TEXT_NODE) {
        el = el.parentElement;
    }

    while (el && el.matches && !el.matches(stopSelector)) {
        if (el.matches(selector)) {
            return el;
        }
        el = el.parentElement;
    }

    //return false;
}

export function findClosestElement(node: Node, elementToFind: HTMLElement, stopSelector?: string): HTMLElement {
    if (!node) return;

    let el: HTMLElement = node.nodeType === Node.TEXT_NODE ? node.parentElement : (node as HTMLElement);

    while (el && el.matches && !el.matches(stopSelector)) {
        if (el === elementToFind) {
            return el;
        }
        el = el.parentElement;
    }

    //return false;
}
